var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.style)},[_c('input',{attrs:{"type":"hidden","name":_vm.name},domProps:{"value":_vm.valueActual}}),_vm._v(" "),_c('jodit-editor',{attrs:{"value":_vm.value,"buttons":_vm.buttons,"config":_vm.config,"plugins":_vm.plugins},on:{"input":function($event){return _vm.update_value($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }